// extracted by mini-css-extract-plugin
export default {"cardWrapper":"ElectricCard_cardWrapper__Rlo52","card":"ElectricCard_card__t9eVF","unit":"ElectricCard_unit__2ethl","num":"ElectricCard_num__L+NDy"};